import PageInfo from "@/components/PageInfo";
import { Container, chakra, Box, Text } from "@chakra-ui/react";
import { Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";

import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";
import { ParentAccordion } from "@/components/faq/ParentAccordion";
import { SchoolerAccordion } from "@/components/faq/SchoolerAccordion";
import { CollegeAccordion } from "@/components/faq/CollegeAccordion";

const Header = () => {
  return (
    <Box my={20} pos="relative">
      <Text pos="absolute" left="0" top="0" fontSize="4xl">
        🖇️
      </Text>

      <chakra.h1
        textStyle="pageHeader"
        fontSize="4rem"
        textAlign="center"
        fontWeight={700}
        color="#000"
        lineHeight="100%"
      >
        Got <chakra.span color="#9559DE">questions?</chakra.span> <br /> We&apos;re here to help.
      </chakra.h1>

      <Text pos="absolute" right="0" bottom="0" fontSize="4xl">
        📝
      </Text>
    </Box>
  );
};

const PageContents = () => {
  return (
    <Box bg="white">
      <Tabs isFitted variant="line">
        <TabList mb="1em">
          <Tab
            fontSize={{ base: "1rem", md: "1.5rem" }}
            color="#1A202C"
            fontFamily="Raleway, sans-serif"
            fontWeight={600}
            display="flex"
            flexDirection={{ base: "column", md: "row" }}
            alignItems="center"
            gap={2}
            px={0}
          >
            <Text>👨‍👩‍👦</Text>
            I'm a parent
          </Tab>

          <Tab
            fontSize={{ base: "1rem", md: "1.5rem" }}
            color="#1A202C"
            fontFamily="Raleway, sans-serif"
            fontWeight={600}
            display="flex"
            flexDirection={{ base: "column", md: "row" }}
            alignItems="center"
            gap={2}
            px={0}
          >
            <Text>👨‍🎓</Text>
            I'm a high schooler
          </Tab>

          <Tab
            fontSize={{ base: "1rem", md: "1.5rem" }}
            color="#1A202C"
            fontFamily="Raleway, sans-serif"
            fontWeight={600}
            display="flex"
            flexDirection={{ base: "column", md: "row" }}
            alignItems="center"
            gap={2}
            px={0}
          >
            <Text>💁‍♂️</Text>
            I'm a college admit
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel p={0}>
            <ParentAccordion />
          </TabPanel>

          <TabPanel p={0}>
            <SchoolerAccordion />
          </TabPanel>

          <TabPanel p={0}>
            <CollegeAccordion />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default function FAQ() {
  return (
    <>
      <PageInfo title="Frequently Answered Questions" themeColor="red.800" />

      <Box
        sx={{
          "&::before": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "-4rem",
            zIndex: "-1",
            background:
              "repeating-linear-gradient(0deg, #F4F4F4, #F4F4F4 1px, #fff 1px, #fff 54px)",
          },
        }}
        mb={"14rem"}
      >
        <Container
          maxW="container.xl"
          paddingInlineStart={{ base: "2rem", "2xl": "1rem" }}
          paddingInlineEnd={{ base: "2rem", "2xl": "1rem" }}
        >
          <Navbar />

          <Header />

          <PageContents />
        </Container>
      </Box>

      <Footer />
    </>
  );
}
